import { useAxios } from '@/utils/axios/useAxios';

export default defineNuxtPlugin({
  name: 'axios',
  parallel: true,
  setup() {
    return {
      provide: {
        axios: useAxios(),
      },
    };
  },
});
